/**
 * Admin API client
 */

import { API_BASE_URL } from '../config/api';
import type { AppEvent } from '@daddytime/events';

export interface AdminEventsQueryParams {
  event_type?: string;
  user_id?: string;
  start_date?: string;
  end_date?: string;
  is_test?: boolean;
  cursor?: string;
  limit?: number;
}

export interface AdminEventsResponse {
  events: AppEvent[];
  cursor?: string;
  hasMore: boolean;
  count: number;
}

function getAuthHeaders(): Record<string, string> {
  try {
    const tokens = localStorage.getItem('auth_tokens');
    if (tokens) {
      const parsed = JSON.parse(tokens);
      if (parsed.accessToken) {
        return { Authorization: `Bearer ${parsed.accessToken}` };
      }
    }
  } catch {
    // ignore
  }
  return {};
}

export async function queryEvents(params: AdminEventsQueryParams): Promise<AdminEventsResponse> {
  const url = new URL('admin/events', API_BASE_URL);

  if (params.event_type) url.searchParams.set('event_type', params.event_type);
  if (params.user_id) url.searchParams.set('user_id', params.user_id);
  if (params.start_date) url.searchParams.set('start_date', params.start_date);
  if (params.end_date) url.searchParams.set('end_date', params.end_date);
  if (params.is_test !== undefined) url.searchParams.set('is_test', String(params.is_test));
  if (params.cursor) url.searchParams.set('cursor', params.cursor);
  if (params.limit) url.searchParams.set('limit', String(params.limit));

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `Request failed with status ${response.status}`);
  }

  return response.json();
}
